import { useState } from "react";

export default function LanguageToggle({ currentLanguage, setLanguage }) {
    const isEnglish = currentLanguage === "en";

    return (
        <div
            className="relative grid grid-cols-[60px_1fr] items-center w-40 h-9 bg-gray-200 rounded-full cursor-pointer py-1"
            onClick={() => setLanguage(isEnglish ? "jp" : "en")}
            role="switch"
            aria-checked={isEnglish}
        >
            {/* Toggle Button */}
            <div
                className={`absolute w-7 left-1 h-6 bg-[#081f60] rounded-full shadow-lg flex items-center justify-center transition-transform transform ${
                    isEnglish ? "translate-x-[0]" : "translate-x-[62px]"
                }`}
            >
                {isEnglish ? (
                    <span className="text-lg">🇬🇧</span> // UK flag emoji for English
                ) : (
                    <span className="text-lg">🇯🇵</span> // Japan flag emoji for Japanese
                )}
            </div>

            {/* English Text */}
            <div className={`pl-2 text-sm font-medium ${isEnglish ? "text-blue-500" : "text-gray-500"}`}>
                <span className="text-lg mr-2">🇬🇧</span>
                <span>EN</span>
            </div>

            {/* Japanese Text */}
            <div className={`pl-2 text-sm font-medium ${!isEnglish ? "text-blue-500" : "text-gray-500"}`}>
                <span className="text-lg mr-2">🇯🇵</span>
                <span>日本語</span>
            </div>
        </div>
    );
}
